export default "__VITE_ASSET__dd6bd1ea__"